/**
 * @author Ketan Shetye
 * @created 2025-10-25
 * @description common button component
 */
import { Component, Input, TemplateRef } from '@angular/core';
import { CommonButtonData } from './common-button.component.model';

@Component({
  selector: 'wm-common-button',
  standalone: false,
  templateUrl: './common-button.component.html',
  styleUrls: ['./common-button.component.scss']
})
export class CommonButtonComponent {

  private _data: CommonButtonData = {
    text: '',
    variant: 'basic',
    className: '',
    type: 'button',
    disabled: false,
    iconName:'',
    disableRipple: false,
    onClick: (event) => {}
  };

  @Input({ required: true })
  set data(value: CommonButtonData) {
    this._data = {
      text: '',
      variant: 'basic',
      className: '',
      type: 'button',
      disabled: false,
      disableRipple: false,
      iconName:'',
      onClick: () => {},
      ...value // merge passed value with defaults
    };
  }

  get data(): CommonButtonData {
    return this._data;
  }

  isTemplate(value: any): value is TemplateRef<any> {
    return value instanceof TemplateRef;
  }

  handleClick(event: Event): void {
    if (this.data.disabled) {
      return;
    }
    if (this.data.onClick) {
      this.data.onClick(event);
    }
  }
}
